import React from 'react';
import { RefreshCw, X } from 'lucide-react';
import useVersionCheck from '../hooks/useVersionCheck';

/**
 * UpdateBanner — flutua no topo quando há nova versão da app publicada.
 * O usuário pode clicar para atualizar (reload com bypass de cache) ou
 * dispensar (volta a aparecer no próximo polling se ainda houver atualização).
 */
const UpdateBanner = () => {
  const { updateAvailable, reload } = useVersionCheck();
  const [dismissed, setDismissed] = React.useState(false);

  if (!updateAvailable || dismissed) return null;

  return (
    <div
      className="fixed left-1/2 -translate-x-1/2 z-[70] bg-blue-600 text-white rounded-full shadow-2xl shadow-blue-500/30 flex items-center gap-2 px-4 py-2.5 animate-bounce-once"
      style={{
        // Ficar acima do BottomNavBar no mobile e visível no desktop
        bottom: 'calc(env(safe-area-inset-bottom, 0px) + 88px)',
      }}
      role="status"
      aria-live="polite"
    >
      <RefreshCw className="w-4 h-4 shrink-0" />
      <span className="text-sm font-medium">Nova versão disponível</span>
      <button
        onClick={reload}
        className="ml-1 bg-white text-blue-700 hover:bg-blue-50 text-xs font-bold px-3 py-1 rounded-full transition-colors"
      >
        Atualizar
      </button>
      <button
        onClick={() => setDismissed(true)}
        className="ml-1 p-1 rounded-full hover:bg-white/10 transition-colors"
        aria-label="Dispensar"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
};

export default UpdateBanner;
